export const QUESTION_TYPE_LABELS: Record<string, string> = {
  multiple_choice: '選擇題',
  true_false: '是非題',
  fill_in_blank: '填充題（供詞）',
  fill_in_blank_without_options: '填充題（不供詞）',
  short_answer: '簡答題',
  reading_comprehension: '閱讀理解',
  essay: '作文',
  ordering: '排序題',
  matching: '配對題',
  punctuation: '標點符號題',
};

export function getQuestionTypeLabel(type: string): string {
  return QUESTION_TYPE_LABELS[type] ?? type;
}
